import {
    LOADED_PROFILE_BASIC,
    LOADING_PROFILE_BASIC,
    MAILING_REGION,
    MAILING_TOWN_TYPE,
    PROFILE_BASIC,
} from '../store/actionTypes';

export const profileBasic = (state = {}, action) => {
    switch (action.type) {
        case PROFILE_BASIC:
            return action.object;
        default:
            return state;
    }
};
export const mailingRegion = (state = [], action) => {
    switch (action.type) {
        case MAILING_REGION:
            return action.list;
        default:
            return state;
    }
};
export const mailingTownType = (state = [], action) => {
    switch (action.type) {
        case MAILING_TOWN_TYPE:
            return action.list;
        default:
            return state;
    }
};
export const loadingProfileBasic = (state = false, action) => {
    switch (action.type) {
        case LOADING_PROFILE_BASIC:
            return action.status;
        default:
            return state;
    }
};
export const loadedProfileBasic = (state = false, action) => {
    switch (action.type) {
        case LOADED_PROFILE_BASIC:
            return action.status;
        default:
            return state;
    }
};
